module.exports = __webpack_public_path__ + "static/media/19-12.77bf4517.mp3";